import { FC } from 'react'
import { Box } from '@mui/material'
import SyllabusSetupMainForm from 'components/organisms/forms/SyllabusSetupMainForm'
import SyllabusSetupContactForm from 'components/organisms/forms/SyllabusSetupContactForm'
import SyllabusSetupPolicyForm from 'components/organisms/forms/SyllabusSetupPolicyForm'
import SyllabusSetupAcademicForm from 'components/organisms/forms/SyllabusSetupAcademicForm'
import SyllabusSetupGradingForm from 'components/organisms/forms/SyllabusSetupGradingForm'
import PageHeading from 'components/atoms/PageHeading'
import { useTranslation } from 'react-i18next'

const SyllabusSetupPage: FC<{}> = () => {

  const { t } = useTranslation()

  return (
    <Box px={2}>
      <PageHeading title={t('common.syllabus-panel')} />
      <Box sx={{padding: '30px'}} mb={3}><SyllabusSetupMainForm /></Box>

      <PageHeading title={t('common.course')} />
      <Box sx={{padding: '30px'}} mb={3}><SyllabusSetupContactForm /></Box>

      <Box sx={{padding: '30px'}} mb={3}><SyllabusSetupPolicyForm /></Box>

      <PageHeading title={t('common.academic-work-expectation')} />
      <Box sx={{padding: '30px'}} mb={3}><SyllabusSetupAcademicForm /></Box>

      <PageHeading title={t('common.grading-plan')} />
      <Box sx={{padding: '30px'}}><SyllabusSetupGradingForm /></Box>
    </Box>
  )
}
export default SyllabusSetupPage
